import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-user-swiper-get-card',
  templateUrl: './user-swiper-get-card.component.html',
  styleUrls: ['./user-swiper-get-card.component.scss']
})
export class UserSwiperGetCardComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
